import styled from 'styled-components';
import { Container } from 'react-bootstrap';
const containerWidth = '50%';
const textPadding = '5.25rem';
interface StyleProps {
  curriculum: string;
}
export const StyledNoAssessments = styled(Container).withConfig({
  displayName: "DpNoAssessmentsstyled__StyledNoAssessments",
  componentId: "sc-h8whpe-0"
})(["align-items:center;display:flex;flex-direction:column;margin-top:", ";width:", ";> img{height:calc(", " * 7);width:calc(", " * 7);}> .text{font-family:", ";color:", ";font-weight:500;padding:0 ", ";text-align:center;width:704px;line-height:1.43;letter-spacing:normal;}> .main{font-size:", ";margin-top:", ";}> .sub{font-size:calc(", " * 1.5);font-weight:400;}> .footer-text{color:", ";font-size:", ";margin:", ";> a{color:", ";font-style:italic;margin-left:", ";text-decoration:underline;}}"], ({
  theme: {
    Spacing
  }
}) => Spacing.x7, containerWidth, ({
  theme: {
    Spacing
  }
}) => Spacing.x5, ({
  theme: {
    Spacing
  }
}) => Spacing.x5, ({
  theme: {
    Typography
  }
}) => Typography.quicksandFontFamily, ({
  theme: {
    Colors
  }
}) => Colors.Typography.secondary, textPadding, ({
  theme: {
    Typography
  }
}) => Typography.Sizes.xxl, ({
  theme: {
    Spacing
  }
}) => Spacing.x4, ({
  theme: {
    Typography
  }
}) => Typography.Sizes.smd, ({
  theme: {
    Colors
  },
  curriculum
}) => Colors.Curriculum[curriculum].action, ({
  theme: {
    Typography
  }
}) => Typography.Sizes.sm, ({
  theme: {
    Spacing
  }
}) => `${Spacing.x3} 0`, ({
  theme: {
    Colors
  },
  curriculum
}) => Colors.Curriculum[curriculum].action, ({
  theme: {
    Spacing
  }
}) => Spacing.x2);